import { Reveal } from "./Reveal";

const renderWithHighlight = (text, highlight) => {
  if (!highlight || !text.includes(highlight)) return text;
  const idx = text.indexOf(highlight);
  return (
    <>
      {text.slice(0, idx)}
      <span className="text-brand">{highlight}</span>
      {text.slice(idx + highlight.length)}
    </>
  );
};

export const SectionHeading = ({ chapter, microtitle, titleA, titleB, highlightWord, description, light = false }) => (
  <div className="mb-12 md:mb-16" data-testid={`section-heading-${microtitle ? microtitle.toLowerCase().replace(/\s+/g, "-") : "default"}`}>
    <Reveal>
      <div className="mb-5 flex items-center gap-4">
        {chapter && (
          <span className={`font-display text-xs font-extrabold tracking-[0.2em] ${light ? "text-steel" : "text-steel"}`}>
            CAP. {chapter}
          </span>
        )}
        <span className="h-px w-10 bg-brand" />
        <p className="microtitle">{microtitle}</p>
      </div>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className={`font-display text-4xl font-extrabold leading-[1.02] tracking-tight sm:text-5xl lg:text-6xl ${light ? "text-inktext" : "text-paper"}`}>
        {titleA}
        {titleB && (
          <>
            <br />
            {renderWithHighlight(titleB, highlightWord)}
          </>
        )}
      </h2>
    </Reveal>
    {description && (
      <Reveal delay={0.16}>
        <p className={`mt-6 max-w-xl text-base leading-relaxed md:text-lg ${light ? "text-steel" : "text-mist"}`}>
          {description}
        </p>
      </Reveal>
    )}
  </div>
);
